// Absence Icons Component - Reusable icons for leave and sickness
import React from 'react';

// Icon URLs
const SANTE_ICON = '/icons/sante.gif';
const VACANCES_ICON = '/icons/vacances.gif';

// Types d'absences - constantes pour cohérence avec le backend
const CONGE_TYPES = ['conge', 'paidLeave'];
const MALADIE_TYPES = ['maladie', 'sickLeave'];
const SANS_SOLDE_TYPES = ['sans_solde', 'unpaidLeave'];

// Determine icon based on absence type
export const getAbsenceIcon = (absenceType) => {
  const isMaladie = MALADIE_TYPES.includes(absenceType);
  const isConge = CONGE_TYPES.includes(absenceType);
  const isSansSolde = SANS_SOLDE_TYPES.includes(absenceType);
  
  if (isMaladie) return SANTE_ICON;
  if (isConge) return VACANCES_ICON;
  // Sans solde utilise aussi l'icône vacances mais pourrait avoir sa propre icône
  if (isSansSolde) return VACANCES_ICON;
  return null;
};

// Icon component with configurable size
export function AbsenceIcon({ type, size = 16, className = '', title = '' }) {
  const iconSrc = getAbsenceIcon(type);
  
  if (!iconSrc) return null;
  
  const isMaladie = MALADIE_TYPES.includes(type);
  const isSansSolde = SANS_SOLDE_TYPES.includes(type);
  const defaultTitle = isMaladie ? 'Maladie' : isSansSolde ? 'Sans solde' : 'Congés';
  
  return (
    <img 
      src={iconSrc}
      alt={title || defaultTitle}
      title={title || defaultTitle}
      width={size}
      height={size}
      className={`inline-block flex-shrink-0 ${className}`}
      style={{ verticalAlign: 'middle' }}
    />
  );
}

// Maladie icon specifically
export function MaladieIcon({ size = 16, className = '', title = 'Maladie' }) {
  return (
    <img 
      src={SANTE_ICON}
      alt={title}
      title={title}
      width={size}
      height={size}
      className={`inline-block flex-shrink-0 ${className}`}
      style={{ verticalAlign: 'middle' }}
    />
  );
}

// Vacances icon specifically
export function VacancesIcon({ size = 16, className = '', title = 'Congés' }) {
  return (
    <img 
      src={VACANCES_ICON}
      alt={title}
      title={title}
      width={size}
      height={size}
      className={`inline-block flex-shrink-0 ${className}`}
      style={{ verticalAlign: 'middle' }}
    />
  );
}

export default AbsenceIcon;
